/* unplugin-vue-components disabled */import script from "./NotePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotePage.vue?vue&type=script&setup=true&lang=ts"

import "./NotePage.vue?vue&type=style&index=0&id=130c081b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130c081b"]])

export default __exports__